import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/context/AuthContext";
import { rememberVantaggiVisit } from "@/lib/attribution";
import { Hero, Band, TodayPerks, PointsIntro, HowItWorks, WhyNow, SignupBlock, Finale } from "@/components/vantaggi/Sections";

// Sezioni modulari: in futuro si potranno inserire saldo punti, missioni, catalogo premi ecc.
const SECTIONS = [Hero, Band, TodayPerks, PointsIntro, HowItWorks, WhyNow, SignupBlock, Finale];

export default function Vantaggi() {
  const { user, loading } = useAuth();
  const { search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => { if (!loading && !user) rememberVantaggiVisit(search); }, [loading, user, search]);
  return (
    <div data-testid="vantaggi-page">
      <SEO
        rawTitle="Vantaggi Readoo | L’informazione che ti premia"
        description="Iscriviti a Readoo, accedi ai vantaggi Premium e scopri Readoo Punti: il nuovo programma che trasformerà informazione e partecipazione in premi."
      />
      {SECTIONS.map((S, i) => <S key={i} />)}
    </div>
  );
}
